<template>
  <v-card
    class="mx-auto"
    max-width="344"
  >
    <v-card-text>
      <p class="text-h4 text--primary">
        {{this.label_en}}
      </p>
      <div class="text--primary">
        {{this.value}}
      </div>
    </v-card-text>
    <v-card-actions>
<v-dialog
      v-model="dialog"
      persistent
      max-width="600px"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          color="primary"
          text
          class="elevation-1 mb-2"
          v-bind="attrs"
          v-on="on"
          rounded
          style="width:35%;"
        >
          Update
        </v-btn>
      </template>
      <v-card>
        <v-card-title>
          <span class="text-h5">{{this.label_en}}</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12">
                <v-text-field
                  label="Value*"
                  v-model="value"
                  required
                ></v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            text
            @click="dialog = false"
          >
            Close
          </v-btn>
          <v-btn
            color="blue darken-1"
            text
            :loading="loading"
            @click="save"
          >
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    </v-card-actions>
  </v-card>
</template>

<script>
import { mapFields } from "vuex-map-fields";
import { mapActions } from "vuex";
export default {
    props: ["label_en", "value", "id"],
    computed: {
         ...mapFields("case_tracking", ["allCaseTracking2"]),
    },
    methods: {
        ...mapActions("case_tracking", ["fetchAllCaseTracking2", "updateCaseTracking2"]),
        async save() {
        this.loading = true;
        await this.updateCaseTracking2({
          id: this.id,
          value: this.value,
        });
        await this.fetchAllCaseTracking2();
        this.loading = false;
        this.dialog = false;
    },
    },
    data() {
        return {
            dialog: false,
            loading: false,
        };
    },
}
</script>
